module.exports = __webpack_public_path__ + "static/img/loading.fa0620b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/loading.gif
// module id = GWb0
// module chunks = 1